import React from 'react';
import { Spin } from 'antd';
import FeatureLockedPage from '../components/FeatureLockedPage';
import type { FeatureKey } from './registry';
import { useFeature } from './useFeature';

interface FeatureRouteProps {
  name: FeatureKey;
  children: React.ReactNode;
}

/**
 * Route guard for feature-flag gated pages. While the flag bundle is still
 * resolving we render a centred spinner — never redirect — so a
 * not-yet-loaded flag can't masquerade as "feature disabled". When the
 * feature is genuinely off (typically because the tenant's plan doesn't
 * include it), we render the upsell paywall instead of silently
 * navigating away.
 */
export function FeatureRoute({ name, children }: FeatureRouteProps) {
  const { enabled, loading } = useFeature(name);
  if (loading) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <Spin />
      </div>
    );
  }
  if (!enabled) return <FeatureLockedPage feature={name} />;
  return <>{children}</>;
}
